import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SettingsElasticSearchIndexesRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsElasticSearchIndexes', {
		url: '/admin/elasticsearch/status',
		controllerAs: 'vm',
		controller: SettingsElasticSearchIndexesCtrl,
		templateUrl: '/ng/hub/Settings/ElasticSearch/Indexes/SettingsElasticSearchIndexesCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Settings/ElasticSearch/Indexes/SettingsElasticSearchIndexesCtrl.css'),
			$title: () => 'ElasticSearch Settings',
			indices: ApiResourcify.endpoint('/nosql/indices'),
			tasks: ApiResourcify.endpoint('/nosql/tasks'),
		},
	});
}

export class SettingsElasticSearchIndexesCtrl {
	constructor(Api, modal, indices, tasks) {
		'ngInject';
		// injections
		this.Api = Api;
		this.modal = modal;
		// data
		this.indices = indices;
		this.tasks = tasks;
	}

	async cancelTask(task) {
		const resp = await this.Api.post(`/nosql/tasks/${task.token}/cancel`);
		this.modal.html({
			escapedHtml: `Server responded with: <pre><code>${JSON.stringify(resp, null, 4)}</code></pre>`,
			width: 'full',
			height: 'full',
			header: 'Cancel Result',
		});
		this.tasks = await this.Api.get('/nosql/tasks');
	}

	addIndex() {
		this.showIndexModal = true;
		this.mode = 'new';
		this.editing = {
			index: '',
			language: '',
			version: '',
			shards: 4,
			replicas: 1,
		};
	}

	editIndex(index) {
		this.showIndexModal = true;
		this.mode = 'edit';
		this.editing = index;
	}

	saveIndex() {
		if (this.mode == 'edit') {
			const data = {
				shards: this.editing.shards,
				replicas: this.editing.replicas,
			};
			this.Api.post(`/nosql/indicies/${this.editing.index}`, data);
		} else if (this.mode == 'new') {
			this.Api.post('/nosql/indicies', this.editing);
		}
	}

	assignHubs() {}
}
